import React, { useState, useRef, useEffect, useCallback } from "react";

const GLYPHS = "010101XYZ_<>{}[]=/*+~#λ∆§0xFA4B";

export default function ScrambleText({
  text,
  className = "",
  hover = true,
  autoStart = false,
  duration = 400,
  as: Component = "span",
  ...props
}) {
  const [displayText, setDisplayText] = useState(text);
  const isAnimatingRef = useRef(false);
  const frameRef = useRef(null);

  const startScramble = useCallback(() => {
    if (isAnimatingRef.current) return;
    isAnimatingRef.current = true;

    const startTime = performance.now();
    const originalLength = text.length;

    const animate = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Number of characters already resolved
      const resolvedCount = Math.floor(progress * originalLength);

      let result = "";
      for (let i = 0; i < originalLength; i++) {
        if (text[i] === " " || text[i] === "\n") {
          result += text[i];
        } else if (i < resolvedCount) {
          result += text[i];
        } else {
          result += GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
        }
      }

      setDisplayText(result);

      if (progress < 1) {
        frameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayText(text);
        isAnimatingRef.current = false;
      }
    };

    frameRef.current = requestAnimationFrame(animate);
  }, [text, duration]);

  useEffect(() => {
    setDisplayText(text);
    if (autoStart) {
      startScramble();
    }
    return () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [text, autoStart, startScramble]);

  const handleMouseEnter = () => {
    if (hover) {
      startScramble();
    }
  };

  return (
    <Component
      onMouseEnter={handleMouseEnter}
      className={className}
      {...props}
    >
      {displayText}
    </Component>
  );
}
